import type { ArticleSection } from '@/mocks/articles';

interface ArticleBodyProps {
  sections: ArticleSection[];
}

export default function ArticleBody({ sections }: ArticleBodyProps) {
  return (
    <div className="article-body">
      {sections.map((section, index) => (
        <section key={`section-${index}`}>
          {section.heading && <h3>{section.heading}</h3>}
          {section.paragraphs?.map((paragraph, pIndex) => (
            <p key={`p-${index}-${pIndex}`}>{paragraph}</p>
          ))}
          {section.bullets && section.bullets.length > 0 && (
            <ul>
              {section.bullets.map((bullet, bIndex) => (
                <li key={`b-${index}-${bIndex}`}>{bullet}</li>
              ))}
            </ul>
          )}
        </section>
      ))}
    </div>
  );
}